import React from 'react';
import styled from '@emotion/styled';
import TopBar from '../Home/TopBar';
import qs from 'qs';
import { useSearchParams } from '../../context/SearchParamsContext';
import { useHistory } from 'react-router-dom';
import { useUserContext } from '../../context/UserContext';
import AddressInfo from './AddressInfo';
import AddressResults from './PropertyResults';

const AddressLookup = () => {
  const { user } = useUserContext();
  const searchParams = useSearchParams();
  const history = useHistory();
  const headerSearch = () => {                                                                                                                                          
    const queryString = qs.stringify({
      open: searchParams.isTopSearchOpen ? 1 : 0,
      query: searchParams.topSearchText,
    });
    document.title = '';
    history.push(`/home?${queryString}`);
  };

  const closeDetailsSearch = () => {
    searchParams.setTopSearchText('');
    searchParams.setIsTopSearchOpen(false);
  };
  return (
    <>
      <TopBar
        search={headerSearch}
        searchText={searchParams.topSearchText}
        onSearchTextChange={searchParams.setTopSearchText}
        setSearchOpen={searchParams.setIsTopSearchOpen}
        searchOpen={searchParams.isTopSearchOpen}
        info
        name={user.clientName}
        closeSearch={closeDetailsSearch}
      />
      <div style={{ margin: '0 auto', paddingBottom: 24, maxWidth: 1300}}>
        <div
          style={{ fontSize: 28, fontWeight: 'bold', textAlign: 'center', marginTop: 30, marginBottom: 16 }}
        >
          Property Lookup
        </div>
        <AddressInfo />
      </div>
    </>    
  );
};

export default AddressLookup;
